import React from "react";
import { Link, Outlet } from "react-router-dom";
import binaxpayLogo from "../../assets/Image/binaxpay.png";
import BackButton from "../ui/BackButton";
import "../custom.css";

/**
 * Shared AuthLayout component for authentication pages (Signin, Signup, Forgot).
 * Position: Content panel on Left, Form panel on Right.
 */
const AuthLayout = ({ contentPosition = "left", contentPanel, formPanel, children }) => {
  const isContentLeft = contentPosition === "left";

  const backHomeBtn = (
    <div
      className={`d-flex ${isContentLeft ? "justify-content-end" : "justify-content-start"} mb-2 desktop-back-btn`}
      style={{ marginBottom: "70px" }}
    >
      <BackButton to="/" text="Back to Home" style={{ margin: 0 }} />
    </div>
  );

  return (
    <>
      {/* Mobile Top Navbar (Visible < 1000px) */}
      <nav className="auth-mobile-nav d-flex justify-content-between align-items-center px-4 py-3">
        <div>
          <Link to="/">
            <img src={binaxpayLogo} alt="Binaxpay Logo" style={{ height: "48px", width: "auto" }} />
          </Link>
        </div>
        <div>
          <BackButton to="/" text="Back to Home" style={{ margin: 0 }} />
        </div>
      </nav>

      <div className="auth-container">
        {contentPanel && formPanel ? (
          isContentLeft ? (
            <>
              {/* Content Panel (Left) */}
              <div className="auth-left">
                <div className="auth-animate-left">{contentPanel}</div>
              </div>
              {/* Form Panel (Right) */}
              <div className="auth-right">
                <div className="auth-form-container auth-animate-right">
                  {backHomeBtn}
                  {formPanel}
                </div>
              </div>
            </>
          ) : (
            <>
              {/* Form Panel (Left) */}
              <div className="auth-right">
                <div className="auth-form-container auth-animate-left">
                  {backHomeBtn}
                  {formPanel}
                </div>
              </div>
              {/* Content Panel (Right) */}
              <div className="auth-left">
                <div className="auth-animate-right">{contentPanel}</div>
              </div>
            </>
          )
        ) : (
          children || <Outlet />
        )}
      </div>
    </>
  );
};

export default AuthLayout;
